import { Guid } from '@lsq-frontend/remote-services/enterprise/common';
import { BankAccountTypeDisplay, ISelectOption } from '@lsq-frontend/common-ui';
import { RedactedBankAccount } from '@lsq-frontend/remote-services/all-java/financing-mk0-services';
import { formatBankAccountForDisplay } from './bank-account-format';

export function mapBankAccountsToSelectOptions(
    bankAccounts: RedactedBankAccount[],
    bankAccountTypeDisplay: BankAccountTypeDisplay = null
): ISelectOption<Guid>[] {
    return bankAccounts.map((bankAccount) => ({
        label: formatBankAccountForDisplay(bankAccount, bankAccountTypeDisplay),
        value: bankAccount.bankAccountKey
    }));
}
